import { render, staticRenderFns } from "./Nine.vue?vue&type=template&id=4c0aec80&scoped=true&"
import script from "./Nine.vue?vue&type=script&lang=js&"
export * from "./Nine.vue?vue&type=script&lang=js&"
import style0 from "./Nine.vue?vue&type=style&index=0&id=4c0aec80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0aec80",
  null
  
)

export default component.exports